window.mainInitKit = function() {
  const _Selector = {
    addTocartKitBtn: ".js-kit-bundle"
  };
  window.kitBuilder = {
    _init: function() {
      this._addTocartKit();
    },
    _addTocartKit: function(event) {
      if (document.querySelectorAll(_Selector.addTocartKitBtn).length > 0) {
        document.querySelectorAll(_Selector.addTocartKitBtn).forEach(function(element) {
          if(!element.classList.contains("event__added")){
            element.classList.add('event__added');
            element.addEventListener('click', function(e) {
            let _uniqueBundleId = new Date().getTime().toString(),
            cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            cart.setActiveElement(document.activeElement);
            items = [],
              itemsProp = {},
              counter = 0;
            //COLLECTION PAGE KIT BUNDLE
            if (document.querySelector('.template-collection') || e.currentTarget.closest('.show__products--oncart')) {
              let collectionForm = e.currentTarget.closest('product-form');

              collectionForm.querySelectorAll('.js-kit-items-data').forEach(function(data) {
                let getCurrentQty = 1;
                let tempItem = {};

                tempItem["quantity"] = getCurrentQty;
                tempItem["id"] = parseInt(data.dataset.itemId);
                tempItem["properties"] = {
                  _bundle_kit_id: _uniqueBundleId,
                  _default_kit_qty: getCurrentQty,
                  _bundleTagKit: _uniqueBundleId,
                  __main_kit_product_title: `Included in "${e.currentTarget.closest('.card__content').querySelector('.product-main-title-kit').innerText}"`
                };
                counter++;
                itemsProp[`KITPRODUCT${counter}`] = `${data.dataset.itemTitle} (${getCurrentQty})`;
                itemsProp["__main_kit_bundle_id"] = _uniqueBundleId;
                // itemsProp["__main_kit_product_title"] = `Included in "${document.querySelector('.product-main-title-kit').value}"`;
                items.push(tempItem);
              });
              let temppropcol = {};
              temppropcol["quantity"] = 1;
              temppropcol["id"] = parseInt(collectionForm.querySelector('.product-variant-id').value);
              temppropcol["properties"] = itemsProp;
              items.push(temppropcol);
              var formData = {
                items: items,
              };

            } else {
              //PRODUCT PAGE KIT BUNDLE

              var currentTarget = e.currentTarget.closest('.qty_addtocart--wrapper');

              if(e.currentTarget.closest('.card-information') != null){
                currentTarget = e.currentTarget.closest('.card-information');
              }

              var currentKitTarget = e.currentTarget.closest('product-info').querySelector('.kit__items');

              if(e.currentTarget.closest('product-form').querySelector('.kit__items-inner') != null){
                currentKitTarget = e.currentTarget.closest('product-form').querySelector('.kit__items-inner');
              }

              currentKitTarget.querySelectorAll(".js-kit-items-data").forEach(function(ele) {
                let getCurrentQty = 1;
                let dataQty = Number(ele.dataset.qty);
                if(dataQty){
                  getCurrentQty = dataQty
                }
                let tempItem = {};
                tempItem["quantity"] = getCurrentQty;
                tempItem["id"] = parseInt(ele.dataset.itemId);
                tempItem["properties"] = {
                  _bundle_kit_id: _uniqueBundleId,
                  _default_kit_qty: getCurrentQty,
                  _bundleTagKit: _uniqueBundleId,
                  __main_kit_product_title: `Included in "${document.querySelector('.product-main-title-kit').value}"`
                };
                counter++;
                itemsProp[`KITPRODUCT${counter}`] = `${ele.dataset.itemTitle} (${getCurrentQty})`;
                itemsProp["__main_kit_bundle_id"] = _uniqueBundleId;
                items.push(tempItem);
              });

              let tempprop = {};
              tempprop["quantity"] = parseInt(currentTarget.querySelector('.quantity__input').value);
              tempprop["id"] = parseInt(e.currentTarget.closest('product-form').querySelector('.product-variant-id').value);
              tempprop["properties"] = itemsProp;
              items.push(tempprop);
              var formData = {
                items: items,
              };
            }

            formData['sections'] = window.CartDrawerItems.getSectionsToRender().map((section) => section.id);
            formData['sections_url'] = window.location.pathname;
            // return;
            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            }).then((response) => {
              return response.json();

            }).then((response) => {
              
                var freeGiftElement = document.getElementById('free_gift');
                if (freeGiftElement && freeGiftElement.getAttribute('data-checkeligibility') === 'true') {
                  window.getCart();
                }
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                
                const cartRef = this.cart; // Store the reference to the cart object
                for (let resp in response.items) {
                  response.items[resp]['sections'] = response.sections;
                  cartRef.renderContents(response.items[resp]); // Use the stored reference here
                }
                if (cartRef && cartRef.classList.contains("is-empty"))
                cartRef.classList.remove("is-empty");
                if(cart.querySelector("#cart-notification-product dl") != null){
                  cart.querySelector("#cart-notification-product dl").classList.add("visually-hidden");
                }
              // if(response.status === 200) {
              // } else {
              //   if(document.querySelectorAll('.kit__error-message').length == 0){
              //     let errorMessage = response.message;
              //     let msgElement = document.createElement('p');
              //     msgElement.classList.add("kit__error-message");
              //     let container = document.querySelector('.qty_addtocart--wrapper');
              //     msgElement.textContent = response.message;
              //     container.appendChild(msgElement);
              //   }                
              // }
            }).catch((error) => {
              console.error("Error:", error);
            });

          });   
          }
        })
      }
    },
    _cartActionKitRemove: function(ele) {
      let cartUpdate = {},
        main_babId = ele.getAttribute("data-build-id"),
        mainProductKey = ele.getAttribute("data-mainkey"),
        cart = ele.closest('cart-items') || ele.closest('cart-drawer-items');
      cart.enableLoading(ele.dataset.index);
      ele.closest('.cart-product-item').dataset.key.split(',').forEach(key => {
        cartUpdate[key] = 0;
      });
      let items = {
        updates: cartUpdate,
        sections: cart.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      };
     
      fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(items)
        }).then(function(data) {
          return data.json();
        }).then(responce => {
          cart.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = cart.getSectionInnerHTML(responce.sections[section.section], section.selector);
          }));
        }).catch(function(error) {
          console.error('Request failed', error)
        })
        .finally(() => {
          cart.disableLoading(ele.dataset.index);
        });
    }
  }
  window.kitBuilder._init();
}

window.mainInitKit();